import React from 'react';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';

import { 
    StyledContainer, 
    StyledGrid, 
    StyledH2, 
    StyledInputBtn, 
    StyledTextArea 
} from './Form.style';


class Form extends React.Component {
    state= {
        sender: '',
        email: '',
        phone: '',
        text: '',
        open: false
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
        [name]: value
        });
    }

    handleReset = () => {
        this.setState({    
            sender: '',
            email: '',
            phone: '',
            text: ''     
        })
    }

    toggleAlert = () => {
        this.setState({open: true})
        setTimeout(() => {
            this.setState({open: false})
        }, 4000)
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const {sender, email, phone, text} = this.state;

        fetch(`http://127.0.0.1:4000/send-email?sender=${sender}&email=${email}&phone=${phone}&text=${text}`)
        .then(this.toggleAlert())
        .then(this.handleReset())
        .catch(err => console.log(err))
    }

    render(){

        const {sender, email, text, phone, open} = this.state

        return(
            <StyledContainer id='message' maxWidth='md'>

                <StyledH2>Get in Touch</StyledH2>

                <form onSubmit={this.handleSubmit}>
                    <Grid container>
                        <StyledGrid item md={6} sm={12} xs={12}>
                            <StyledInputBtn
                                required
                                label='Name'
                                value={sender}
                                type="name"
                                name="sender"
                                primary='true'
                                placeholder='Your Name'
                                onChange={this.handleChange}
                            />
                        </StyledGrid>
                        <StyledGrid item md={6} sm={12} xs={12} right_side={true}>
                            <StyledInputBtn
                                required
                                label='email'
                                value={email}
                                type="email"
                                name="email"
                                primary='true'
                                placeholder='Email'
                                onChange={this.handleChange}
                            />
                        </StyledGrid>
                        <StyledGrid item md={12} sm={12} xs={12}>
                            <StyledTextArea
                                required
                                label='message'
                                value={text}
                                placeholder='Message'
                                textarea='true'
                                onChange={this.handleChange}
                                name='text'
                            />
                        </StyledGrid>
                        <StyledGrid item md={6} sm={12} xs={12}>
                            <StyledInputBtn
                                value={phone}
                                label='phone number'
                                primary='true'
                                placeholder='Phone'
                                onChange={this.handleChange}
                                name='phone'
                            />  
                        </StyledGrid>
                        <StyledGrid item md={6} sm={12} xs={12} right_side={true}>
                            <StyledInputBtn
                                type='submit'
                                submit='true'
                            />  
                        </StyledGrid>
                    </Grid>
                </form>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={open}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span>Your message was sent!</span>}
                    />
            </StyledContainer>
        )
    }
}

export default Form;